import { render, staticRenderFns } from "./PocketmagsPlusProduct.vue?vue&type=template&id=59e58e1a"
import script from "./PocketmagsPlusProduct.vue?vue&type=script&lang=js"
export * from "./PocketmagsPlusProduct.vue?vue&type=script&lang=js"
import style0 from "./PocketmagsPlusProduct.vue?vue&type=style&index=0&id=59e58e1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports